export default __webpack_public_path__ + "static/media/customKitchen6CroppedRight.a273d1b0.jpg";